// extracted by mini-css-extract-plugin
module.exports = {"elSection":"Section_elSection__3HjIj","warningModal":"Section_warningModal__1wJKw"};